<div class="wbox full-height">
  <div class="logo"></div>
</div>
